import { ENTITY_ADD_REQUESTS_CRUD_ACTION_CONSTANTS } from '../actions/entity_add_requests_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['entityAddRequestsIndex']);
export default standardReducerGenerator(ENTITY_ADD_REQUESTS_CRUD_ACTION_CONSTANTS, initialState);
